/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.1
 */

import produce from 'immer';
import { Reducer } from 'redux';

import {
    CLEAN_LIST_SUBSCRIBERS,
    LOAD_LIST_SUBSCRIBERS_MAX_COSTS_FAIL,
    LOAD_LIST_SUBSCRIBERS_MAX_COSTS_REQUEST,
    LOAD_LIST_SUBSCRIBERS_MAX_COSTS_SUCCESS,
} from './constants/widgetSubscriberMaxCostsConstants';
import {
    ISubscriberMaxCostReducer,
    WidgetSubscriberMaxCostsType,
} from './widgetSubscriberMaxCostsType';

export const widgetMaxCostInitialState: ISubscriberMaxCostReducer = {
    error: '',
    loading: true,
    subscribers: [],
};

const widgetSubscriberMaxCostReducer: Reducer<ISubscriberMaxCostReducer, WidgetSubscriberMaxCostsType> =
    (
        state: ISubscriberMaxCostReducer = widgetMaxCostInitialState,
        action: WidgetSubscriberMaxCostsType,
    ) =>
        produce(state, draft => {
            switch (action.type) {

                case LOAD_LIST_SUBSCRIBERS_MAX_COSTS_REQUEST:
                    draft.loading = true;
                    break;

                case LOAD_LIST_SUBSCRIBERS_MAX_COSTS_SUCCESS:
                    draft.loading = false;
                    draft.subscribers = action.payload.subscribers;
                    break;

                case LOAD_LIST_SUBSCRIBERS_MAX_COSTS_FAIL:
                    draft.error = action.payload;
                    draft.loading = false;
                    break;
                case CLEAN_LIST_SUBSCRIBERS:
                    draft.error = '';
                    draft.subscribers = [];
                    break;
            }
        });

export default widgetSubscriberMaxCostReducer;
